import React from "react";

const BpayText = () => (
    <>
    <span>B<span className="bpay">PAY<span className="registered">®</span></span></span>
    </>
)

export default BpayText;
